import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Y si mi familia no colabora?',
  answer: 'Empezás igual. El sistema es para que deje de depender de “convencer”. Cuando está armado, la fricción baja porque la información está visible y clara para todos, no solo en tu cabeza.'
}, {
  question: '¿Y si no tengo impresora?',
  answer: 'Podés imprimir en un centro de copiado. Este producto es físico por diseño, porque lo físico se usa cuando hay estrés y no depende de baterías ni contraseñas.'
}, {
  question: '¿Esto es muy complejo?',
  answer: 'No. Está hecho para cuando no te da la cabeza. Si tarda más de 20 minutos por semana, se rompe; por eso es minimalista y va al grano.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#FDFCF8] py-16 md:py-24 px-4" data-id="element-12">
      <div className="max-w-2xl mx-auto" data-id="element-13">
        <h2 className="text-3xl font-serif font-bold text-stone-900 mb-12 text-center" data-id="element-14">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => <div key={index} className="border-b border-stone-200 pb-4" data-id="element-16">
              <button className="w-full flex justify-between items-center text-left py-4 focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-17">
                <span className="text-lg font-bold text-stone-900 pr-8" data-id="element-18">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-stone-500" data-id="element-19" /> : <ChevronDown className="w-5 h-5 text-stone-500" data-id="element-20" />}
              </button>
              {openIndex === index && <div className="pb-4 text-stone-600 leading-relaxed animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-21">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}